import { Card, CardContent, CardHeader, CardTitle } from '@1trading/react';
import { Link } from 'react-router-dom';
import { StatusChip } from '@/components/ui/status-chip';
import { abuseSubjectPath, SUBJECT_TYPE_SINGULAR } from '@/features/abuse/abuse-meta';
import type { AbuseSubjectDetail } from '@/services/api/abuse';

export const LinkedSubjects = ({ detail }: { detail: AbuseSubjectDetail }) => (
  <Card>
    <CardHeader>
      <CardTitle>Linked subjects</CardTitle>
    </CardHeader>
    <CardContent>
      {detail.linked.length === 0 ? (
        <p className="text-sm text-muted-foreground">No linked subjects in this window.</p>
      ) : (
        <ul className="flex flex-wrap gap-2">
          {detail.linked.map((linked) => (
            <li key={`${linked.subjectType}|${linked.subjectId}`}>
              <Link className="inline-flex items-center gap-2 rounded-full border py-1 pr-3 pl-1 text-xs hover:bg-muted" to={abuseSubjectPath(linked)}>
                <StatusChip className="px-2 py-0 text-[11px]" variant="muted">
                  {SUBJECT_TYPE_SINGULAR[linked.subjectType]}
                </StatusChip>
                <span className="font-mono">{linked.subjectId}</span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </CardContent>
  </Card>
);
LinkedSubjects.displayName = 'LinkedSubjects';
